import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {API_URL} from '../../../constants';
import Error from '../../Error/error';
import cookie from 'react-cookies';
import {approveRole, validateUrl, getRoles} from '../../../functions';
import Moment from 'moment';
import {updateValueInJson} from '../../../functions';
import SuscriptorExcel from './suscriptorExcel';
import $ from 'jquery';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { registerLocale, setDefaultLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';
registerLocale('es', es)

export default class SuscriptorFooter extends Component {
    state = {
        dataExcel:[],
        resource: [],
        response: [],
        error: [],
        security: cookie.load('user'),
        roles: [],
        filters:{
            page:1,
            fecha_creacion_inicio:'',
            fecha_creacion_fin:''
        },
        pagina: 1,
        offRows:0,
		startDate: null,
		endDate: null,
        menuGeneral:[],
        agrupador:""
    }
	
	handleChange = date => {
		
		this.setState({
		  startDate: date
		});
	};
	
	handleChangeEnd = date => {
		
		this.setState({
		  endDate: date
		});
	};

    render() {

        Moment.updateLocale('en', {
            months : [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
                "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
            ]
        });

        Moment.updateLocale('en', {
            weekdays : [
                "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
            ]
        });

        return (
            <div>
				{
				<style dangerouslySetInnerHTML={{__html: `
					.divTablaPage_Panel table tr td:last-child {
						padding-left: 10px !important;
						padding-right: 10px !important;
					}
				`}}></style>
				}
				
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="" />
                        <a  href="/">
                            / Panel de configuración general
                        </a >
                        <Link to="/reportes">
                            &nbsp;Reportes
                        </Link>
                        <span> / Suscriptor</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                Suscriptor
                </div>

               <div className="divReporte_Log">
                    <div className="divSearchReporte_Log">
                        <SuscriptorExcel dataReport={this.state.dataExcel}/>
                        <div className="divSearch_Reporte_Log">
                            <DatePicker 
								placeholder="Fecha Inicio"
								name="f_inicio" 
								id="f_inicio"
								locale="es"
								selected={this.state.startDate}
								onChange={this.handleChange}
								dateFormat="yyyy-MM-dd"
							/>
							<DatePicker 
								placeholder="Fecha Fin"
								name="f_fin" 
								id="f_fin"
								locale="es"
								selected={this.state.endDate}
								onChange={this.handleChangeEnd}
								dateFormat="yyyy-MM-dd"
							/>
                            <input type="submit" defaultValue="Buscar" onClick={(event) => this.callFunctionButton(event)}/>
                        </div>
                        <div className="clear" />
                    </div>	
                    <div className="divTablaPage_Panel">
                        <table border={1} cellSpacing={0}>
                        <tbody>
                            <tr>
                                <th>N°</th>
                                <th>Correo</th>
                                <th>Origen</th>
                                <th>IP</th>                           
                                <th>Fecha</th>
                            </tr>
                            {
                                (this.state.response.statusCode===200) ?

                                            this.state.resource.length > 0 ?
                                            
                                            this.state.resource.map((resource, index) => (
                                            <tr key={resource.sfoo_Id}>
                                                <td>{(index + 1) + resource.offset}</td>
                                                <td>{resource.sfoo_Correo}</td>
                                                <td>{resource.sfoo_Seccion}</td>
                                                <td>{resource.sfoo_IpCreacion}</td>
                                                <td>{Moment(resource.sfoo_FechaCreacion).format('DD/MM/YYYY')}</td>
                                            </tr>
                                            ))

                                            :

                                            (<tr>
                                                <td colspan="5" className="tdSinResultados">
                                                    No se encontró resultados.
                                                </td>
                                            </tr>)
                                
                                : (<tr>
                                    <td colspan="5" className="tdSinResultados">
										No se encontró resultados.
                                    </td>
                                </tr>)
                            }

                        </tbody></table>
                    </div>
                    {this.paginationTable()}
                    <div className="clear" />
                </div>

            </div>
        )
    }

    loadDataExcel = (finicio = '', ffin = '') => {

        let dataForm = {};
        dataForm.fecha_creacion_inicio = finicio;
        dataForm.fecha_creacion_fin = ffin;
        dataForm.page = -1;

        const url = `${API_URL}ReporteUX/SuscriptorFooter/`;
        const formData = JSON.stringify(dataForm);

        axios.post(
            url, 
            JSON.stringify(formData),
            { headers: {
                        'Content-Type': 'application/json; charset=UTF-8' ,
                        'Accept': 'application/json'
                        }
            }).then(
            (data)=> {   
                let dataResult = data.data;  
                this.setState({ dataExcel: dataResult.result });
            
            }).catch((error)=> {
                this.setState({loading:false});
            }); 
    }


    callFunctionButton = (event) => {

        event.preventDefault();

        var finicio = document.getElementById('f_inicio').value;
        var ffin = document.getElementById('f_fin').value;

        var dataForm = this.state.filters;
        dataForm.fecha_creacion_inicio = finicio;
        dataForm.fecha_creacion_fin = ffin;
        dataForm.page = 1;
        
        this.setState(dataForm);

        const url = `${API_URL}ReporteUX/SuscriptorFooter/`;
        const formData = JSON.stringify(dataForm);

        axios.post(
            url, 
            JSON.stringify(formData),
            { headers: {
                        'Content-Type': 'application/json; charset=UTF-8' ,
                        'Accept': 'application/json'
                        }
            }).then(
            (data)=> {   

                let dataResult = data.data;       
                let offRows = 0;
                if(dataResult.result.length > 0){
                    offRows = dataResult.result[0].offset * 1;
                }
                this.setState({ resource: dataResult.result, response: dataResult, error: dataResult.Error, offRows:offRows,filters:dataForm });
				this.ShowPaginationFive(0);
            
            }).catch((error)=> {
                this.setState({loading:false});
            }); 

            this.loadDataExcel(finicio, ffin);
    }

	executePaginationPrev(page, e)
	{
		if(!$(".divPaginador a.active").prev().hasClass("btnPrevPaginador"))
		{			
			this.executePagination(parseInt($(".divPaginador a.active").prop("id"))-1, e);
		}
	}
	
	executePaginationNext(page, e)
	{
		if(!$(".divPaginador a.active").next().hasClass("btnNextPaginador"))
		{
			this.executePagination(parseInt($(".divPaginador a.active").prop("id"))+1, e);
		}
	}
	
    executePagination(page, e){

        if(e != undefined){
            e.preventDefault();
        }

        var roles = this.state.security.cRolesxUsuario.filter(option=> { return option.cRoles.nTipSistema==="0"; });
        var flag = approveRole(roles);
        //var estados= (flag?('A,R'):('B'));
        var usuario = (flag?(0):(this.state.security.nUsuCodigo));

        let textoFilter = this.state.filters.texto;

        const url = `${API_URL}ReporteUX/SuscriptorFooter/`;

        var dataForm = this.state.filters;
        dataForm.page = page;
        const formData = JSON.stringify(dataForm);

        var entity = this.state.resource.length>0?this.state.resource[0]:null;

        for(let index=0; index < entity.totalPages+2; index++)
        {
            if($("#"+index).is("*"))
			{
				document.getElementById(index).classList.remove("active");
			}
        }
        
        if($("#"+page).is("*")){
			document.getElementById(page).classList.add("active");
		}

		$(".ipl-progress-indicator").fadeIn();
		$(".ipl-progress-indicator-head").css({"width": "90%"});
		
        axios.post(
            url, 
            JSON.stringify(formData),
            { headers: {
                        'Content-Type': 'application/json; charset=UTF-8' ,
                        'Accept': 'application/json'
                        }
            }).then(
            (data)=> {   

				$(".ipl-progress-indicator-head").css({"width": "100%"});
				setTimeout(function()
				{
					$(".ipl-progress-indicator").hide();
					$(".ipl-progress-indicator-head").css({"width": "0%"});
				}, 200);
				
                let dataResult = data.data;       
                let offRows = 0;
                if(dataResult.result.length > 0){
                    offRows = dataResult.result[0].offset * 1;
                }
                this.setState({ resource: dataResult.result, response: dataResult, error: dataResult.Error, roles : roles, pagina: page, offRows:offRows });
				this.ShowPaginationFive(page-1);
            
            }).catch((error)=> {
                this.setState({loading:false});
            }); 
    }

    paginationTable()
    {
        var entity = this.state.resource.length > 0 ? this.state.resource[0] : null;

        const options = [];

        if (entity !== null){

            if(entity.totalPages == 1){
                return null;
            }

            options.push(<a className="btnPrevPaginador" id={0} key={0} onClick={(e) => this.executePaginationPrev(0, e)}></a>);
            
            for(let index=1; index < entity.totalPages+1; index++)
                options.push(<a className="pageItem" id={index} key={index} onClick={(e) => this.executePagination(index, e)}> {index} </a>);

            options.push(<a className="btnNextPaginador" id={entity.totalPages+1} key={entity.totalPages+1} onClick={(e) => this.executePaginationNext(entity.totalPages+1, e)}></a>);

        return (
            <div className="divPaginador" key={"pagination"} id="pagination">
                {options}
            </div>
        );
        }
    }
	
	ShowPaginationFive(pagina)
	{
		$(".divPaginador a.active").removeClass("active");
		$(".divPaginador a:eq("+pagina+")").next().addClass("active");
		
		$(".divPaginador .pageItem").hide();
		
		let ItemPage = parseInt($(".divPaginador a.active").prop("id"));
		if(ItemPage < 4)
		{
			$(".divPaginador .pageItem").slice(0,5).show();
		}
		else if(ItemPage < 5)
		{
			$(".divPaginador .pageItem").slice(1,6).show();
		}
		else if(ItemPage < 6)
		{
			$(".divPaginador .pageItem").slice(2,7).show();
		}
		else if(ItemPage >= 6)
		{
			$(".divPaginador .pageItem.active").prev().prev().show();
			$(".divPaginador .pageItem.active").prev().show();
			$(".divPaginador .pageItem.active").show();
			$(".divPaginador .pageItem.active").next().show();
			$(".divPaginador .pageItem.active").next().next().show();
		}
		
		if(!$(".pageItem.active").next().hasClass("pageItem")){
		  if($(".pageItem.active").prev().prev().prev().hasClass("pageItem")){
			  $(".pageItem.active").prev().prev().prev().show()
		  }
		}
		if(!$(".pageItem.active").next().next().hasClass("pageItem")){
		  if($(".pageItem.active").prev().prev().prev().prev().hasClass("pageItem")){
			  $(".pageItem.active").prev().prev().prev().prev().show()
		  }
		}
    }
    
    loadMenus = (agrupador = "") => {

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";
        let sUrl = this.props.location.pathname;

        const url = `${API_URL}MenuUX/${rol}`;

        axios.get(url).then(response => response.data)
        .then((data) => {

          let menuTemp = [{
            sAgrupador:"Administradores",
            sOpcNombre:"Menus",
            sUrl:"/menu"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorias de Certificaciones",
            sUrl:"/categorias-certificacion"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorías de Exporta Fácil",
            sUrl:"/categorias-exporta-facil"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorías de Preguntas Frecuentes",
            sUrl:"/categorias-faq"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorías de Herramientas de Análisis",
            sUrl:"/categorias-herramienta-analisis"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Categorías de Puede Interesarte",
            sUrl:"/categorias-puede-interesarte"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Páginas",
            sUrl:"/paginas"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de H. de Análisis",
            sUrl:"/herramientas-analisis"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Certificaciones",
            sUrl:"/certificaciones"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Oficinas en el Mundo",
            sUrl:"/oficinas-mundo"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. También Puede Interesarte",
            sUrl:"/puede-interesarte"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Documentación para Exportar",
            sUrl:"/documento-exportacion"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Guías para el Exportador",
            sUrl:"/guia-exportador"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Categorías Potencial de Exportación",
            sUrl:"/categorias-potencial-exportador"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. Exporta Fácil",
            sUrl:"/exporta-facil"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. Productos Priorizados por Sector y Mercado",
            sUrl:"/productos-priorizado"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de H. para Pymes",
            sUrl:"/herramientas-pyme"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. H. Externas",
            sUrl:"/herramientas-externa"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Programas de Capacitación",
            sUrl:"/programas-capacitacion"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. de Glosarios",
            sUrl:"/glosario"
          },
          {
            sAgrupador:"Administradores",
            sOpcNombre:"Adm. FAQ",
            sUrl:"/faqs"
          },
          {
            sAgrupador:"Usuarios",
            sOpcNombre:"Usuarios",
            sUrl:"/usuarios"
          },
          {
            sAgrupador:"Usuarios",
            sOpcNombre:"Roles",
            sUrl:"/perfiles"
          },
          {
            sAgrupador:"Reportes",
            sOpcNombre:"Encuestas",
            sUrl:"/reporte-encuesta"
          },
          {
            sAgrupador:"Reportes",
            sOpcNombre:"Logs",
            sUrl:"/reporte-logs"
          },
          {
            sAgrupador:"Reportes",
            sOpcNombre:"Suscriptor",
            sUrl:"/reporte-suscriptor-footer"
          },
          {
            sAgrupador:"Reportes",
            sOpcNombre:"Trazabilidad",
            sUrl:"/reporte-trazabilidad"
          },
          {
            sAgrupador:"Configuradores",
            sOpcNombre:"Panel de Configuración",
            sUrl:"/configuradores"
          }]

          menuTemp.map((menu) => (
            data.result.push(menu)
          ))
      
          var menuGeneral = data.result;

          validateUrl(menuGeneral, sUrl, ""); 

          if(menuGeneral != null){
            this.setState({
                menuGeneral: menuGeneral,
                agrupador: "Reportes"
            });
          }
      })
      .catch(error => {
          console.log(error);
      });
    }

    componentDidMount(){

        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let newState = this.props.location.state;
        if(newState != undefined){  

            let sUrl = this.props.location.pathname;

            validateUrl(newState.menuGeneral, sUrl);     

            this.setState({
                menuGeneral: newState.menuGeneral,
                agrupador: newState.agrupador
            });            
        }else{
            this.loadMenus();
        }

        var roles = this.state.security.cRolesxUsuario.filter(option=> { return option.cRoles.nTipSistema==="0"; });
        var flag = approveRole(roles);
        //var estados= (flag?('A,R'):('B'));
        var usuario = (flag?(0):(this.state.security.nUsuCodigo));

        const url = `${API_URL}ReporteUX/SuscriptorFooter/`;

        var dataForm = this.state.filters;
        const formData = JSON.stringify(dataForm);

        axios.post(
            url, 
            JSON.stringify(formData),
            { headers: {
                        'Content-Type': 'application/json; charset=UTF-8' ,
                        'Accept': 'application/json'
                        }
            }).then(
            (data)=> {   
                let dataResult = data.data;       
                let offRows = 0;
                if(dataResult.result.length > 0){
                    offRows = dataResult.result[0].offset * 1;
                }
                this.setState({ resource: dataResult.result, response: dataResult, error: dataResult.Error, roles : roles, pagina: 1, offRows:offRows });
				this.ShowPaginationFive(0);
            
            }).catch((error)=> {
                this.setState({loading:false});
            }); 
            
		this.loadDataExcel();
		$("#f_inicio").attr("placeholder", "Fecha de Inicio");
		$("#f_fin").attr("placeholder", "Fecha Fin");
    }
}
